<template>
  <div>
    <div class="btn-group pull-right document-action">
      <template v-if="$user.isBasic()">
        <a v-if="document.publication === 'internal'" class="btn btn-sm btn-info btn-outline" :href="document.link" target="_blank">
          View document
        </a>
        <button v-else class="btn btn-sm btn-info btn-outline" @click="onClick('searchDocRef', $event)" title="Subscribe to advanced Account">
          View document <i class="fa fa-lock font-bold"></i>
        </button>
        <template v-if="document.publication !== 'internal'">
          <button class="btn btn-sm btn-info btn-outline" @click="onClick('share',$event)"> Share</button>
        </template>
        <button class="btn btn-sm btn-info" :class="(document.biblio === true) ? 'disabled' : ''"
                @click="onClick('saveToBiblio',$event)" title="Subscribe to Seeker Account">
          Save to Biblio <i class="fa fa-lock font-bold"></i>
        </button>
      </template>
      <template v-else>
        <template v-if="document.link">
          <a class="btn btn-sm btn-info btn-outline" :href="document.link" target="_blank">
            View document
          </a>
        </template>
        <router-link v-else :to="{name: 'DocumentReference', params: {document_id: document.documentID}}" target="_blank" class="btn btn-sm btn-sm btn-info btn-outline"> View document</router-link>
        <template v-if="document.publication !== 'internal'">
          <button class="btn btn-sm btn-info btn-outline" @click="onClick('share',$event)"> Share</button>
        </template>
        <button class="btn btn-sm btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" :class="!$user.hasAdvanceNews() ? 'disabled' : ''"> Save to Biblio </button>
        <ul class="dropdown-menu dropdownCopyBox" aria-labelledby="dropdownCopy" style="z-index: 999999;">
          <li style="width: 100%; padding: 5px 5px" :class="testInBoxes(generateBoxKey()) || !$user.hasAdvanceNews() ? 'disabled' : ''"
              :title="testInBoxes(generateBoxKey()) ? 'Document already saved in biblio!' : 'Add document to biblio'">
            <template v-if="!testInBoxes(generateBoxKey())">
              <a @click="onClick('saveToBiblio',$event)"> Add to default Box : ({{$route.params.query}})<i class="fa fa-lock font-bold" v-if="!$user.hasAdvanceNews()"></i>
              </a>
            </template>
            <template v-else>
              <a style="color: 3498db">  Add to default Box : ({{$route.params.query}})<i class="fa fa-lock font-bold" v-if="!$user.hasAdvanceNews()"></i></a>
            </template>
          </li>
          <template v-if="biblioBoxes.length">
          <li role="separator" class="divider"></li>
            <div class="dropdownCopyBoxList">
               <li style="width: 100%; padding: 5px 5px" > Add to existing Box :</li>
               <li v-for="box in biblioBoxes" v-if="!testInBoxes(box.key)" :key="box.key" style="width: 100%; padding: 5px 5px"><a href="#" @click="onClick('saveTo',$event)" class="li-copyToBox text-info" :data-targetBox="box.name">{{box.name}} </a></li>
            </div>
          </template>
          <li role="separator" class="divider"></li>
          <li style="width: 100%; padding: 5px 5px" ><a href="#" @click="addKeyword" style="color:#3498db"> <i class="fa fa-plus"></i>  Add  to new box ... </a></li>
        </ul>
      </template>
    </div>

    <template v-if="showShareDoc === true">
      <share-document :document="document" v-model="showShareDoc"></share-document>
    </template>
  </div>
</template>
<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 0;
}
.dropdownCopyBoxList{
  max-height: 370px;
  overflow: hidden;
  overflow-y: scroll;
  padding-left: 20px;
}

.li-copyToBox {
  display: block;
  width: 80%;
  margin-left: 10px;
  padding: 2px 5px;
}

.li-copyToBox:hover {
  background-color: #f5f5f5;
}
</style>
<script>
import ShareDocument from '../../components/modal/ShareDocument'
import VueLadda from 'vue-ladda'
export default {
  name: 'NewsAction',
  props: ['news', 'context', 'biblioBoxes'],
  components: { ShareDocument, VueLadda },
  data () {
    return {
      showShareDoc: false,
      documentInBoxes: [],
      document: {},
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      newKeyword: null,
      showTexteBiblio: 'default'
    }
  },
  methods: {
    onClick: function (action, event) {
      switch (action) {
        case 'share':
          this.showShareDoc = true
          break
        case 'searchDocRef':
          this.context.showLimitPlan('searchDocRef')
          break
        case 'saveToBiblio':
          if (this.$user.hasAdvanceNews()) {
            this.context.addDocumentToBiblio(this.document)
          } else {
            this.context.showLimitPlan('advanceNews')
          }
          break
        case 'saveTo':
          if (this.$user.hasAdvanceNews()) {
            this.document.isCopyTo = true
            this.context.addDocumentToBiblio(this.document, event.target.dataset.targetbox)
          } else {
            this.context.showLimitPlan('advanceNews')
          }
      }
      event.stopPropagation()
      event.preventDefault()
    },
    convertToDocument: function (news) {
      return {
        documentID: news.hashId,
        pubDate: news.datePublished,
        title: news.name,
        publication: news.provider[0].name,
        link: news.url,
        biblio: news.biblio,
        type: 'news',
        co_authors: [],
        abstract: news.description,
        doi: null
      }
    },
    testInBoxes: function (key) {
      return this.documentInBoxes.find((item) => {
        if (item === key) {
          return true
        }
      })
    },
    generateBoxKey: function () {
      let query = this.$route.params.query
      return !query ? null : query.toLowerCase().replace(/(\r\n|\n|\r|\s)/gm, '').split(',').pop().replace(/[\.,'\/#!?|$%\^"&\*;:{><}=\_`~(),]/g, '')
    },
    addKeyword: function (e) {
      this.showModalAddKeyword()
      e.preventDefault()
      e.stopPropagation()
    },
    showModalAddKeyword: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        this.showTexteBiblio = 'boxWithDocument'
        $('#modalAddKeyword').modal('show')
        this.$eventHub.$emit('addKwdWithDoc', this.document)
        this.$eventHub.$emit('showTexte', this.showTexteBiblio) //evenement
      }
    }
  },
  beforeMount () {
    this.document = this.convertToDocument(this.news)
    this.documentInBoxes = this.document.biblio ? this.document.biblio.split(';') : []
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/NewsAction.vue